import { getTechnicalDataColumnsDisplayNamesEnums, techDataColsAPINames } from "../../configs/TechnicalDataEnums";

const TECHNICAL_DATA_KEYS_PREFIX = "TECHNICAL_DATA__";
export const getTechDataPrefix = (key) => {
  return TECHNICAL_DATA_KEYS_PREFIX + key;
};

export const TechnicalDataSummarySectionsNamesEnums = Object.freeze({
  TECHNICAL_DATA__COOLING_SYSTEM_SUMMARY: getTechDataPrefix("coolingSystemSummary"),
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY: getTechDataPrefix("heatingSystemSummary"),
  TECHNICAL_DATA__WINDOW_SUMMARY: getTechDataPrefix("windowSummary"),
});

const TechnicalDataSummarySectionsDisplayNamesEnums = Object.freeze({
  TECHNICAL_DATA__COOLING_SYSTEM_SUMMARY: "Summary of Cooling System ",
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY: "Summary of Heating System ",
  TECHNICAL_DATA__WINDOW_SUMMARY: "Summary of Window ",
});

const TechnicalDataHeatingCoolingSystemSummaryColsDisplayNamesEnums = Object.freeze({
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__AMOUNT_OF_DIFFERENT_SYSTEMS: "Amount of different systems",
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__INSTALLATION_YEARS: "Installation years",
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__MAIN_ENERGY_SOURCE: "Main Energy source",
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__MAIN_SYSTEM_THERMAL_POWER: "Main System Thermal Power",
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__MAIN_SYSTEM_TYPE: "Main System Type",
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__MONITORING_SYSTEM_INSTALLED: "Monitoring system installed",
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__TOTAL_THERMAL_POWER: "Total thermal power kW",
});

const TechnicalDataWindowSummaryColsDisplayNamesEnums = Object.freeze({
  TECHNICAL_DATA__WINDOW_SUMMARY__AMOUNT_OF_DIFFERENT_WINDOWS: "Amount of different windows",
  TECHNICAL_DATA__WINDOW_SUMMARY__G_VALUE_RANGE: "G value range",
  TECHNICAL_DATA__WINDOW_SUMMARY__MAIN_WINDOW_TYPE: "Main window type",
  TECHNICAL_DATA__WINDOW_SUMMARY__TOTAL_NUMBER_OF_WINDOWS: "Total number of windows",
  TECHNICAL_DATA__WINDOW_SUMMARY__U_VALUE_RANGE: "U value range",
});

export const TechnicalDataColsDisplayNamesEnums = Object.freeze({
  TECHNICAL_DATA__AREA: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.AREA),
  TECHNICAL_DATA__AREA_COVERED: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.AREA_COVERED),
  TECHNICAL_DATA__CAPACITY_PANEL: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.CAPACITY_PANEL),
  TECHNICAL_DATA__COLOR: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.COLOR),
  TECHNICAL_DATA__COP: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.COP),
  TECHNICAL_DATA__DC_AC_INVERTER_CONFIGURATION: getTechnicalDataColumnsDisplayNamesEnums(
    techDataColsAPINames.DC_AC_INVERTER_CONFIGURATION
  ),
  TECHNICAL_DATA__DESCRIPTION: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.DESCRIPTION),
  TECHNICAL_DATA__DISTRIBUTION_LOSSES: getTechnicalDataColumnsDisplayNamesEnums(
    techDataColsAPINames.DISTRIBUTION_LOSSES
  ),
  TECHNICAL_DATA__ENERGY_SOURCE: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.ENERGY_SOURCE),
  TECHNICAL_DATA__G_VALUE: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.G_VALUE),
  TECHNICAL_DATA__INFILTRATION: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.INFILTRATION),
  TECHNICAL_DATA__INSTALLED: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.INSTALLED),
  TECHNICAL_DATA__LAST_CHECKED: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.LAST_CHECKED),
  TECHNICAL_DATA__MANUFACTURER_NAME: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.MANUFACTURER_NAME),
  TECHNICAL_DATA__MODERNIZATION: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.MODERNIZATION),
  TECHNICAL_DATA__MONITORING_INSTALLED: getTechnicalDataColumnsDisplayNamesEnums(
    techDataColsAPINames.MONITORING_INSTALLED
  ),
  TECHNICAL_DATA__NUMBER_OF_WINDOWS: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.NUMBER_OF_WINDOWS),
  TECHNICAL_DATA__PEAK_THERMAL_POWER: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.PEAK_THERMAL_POWER),
  TECHNICAL_DATA__STORAGE_LOSSES: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.STORAGE_LOSSES),
  TECHNICAL_DATA__STORAGE_TEMPERATURE: getTechnicalDataColumnsDisplayNamesEnums(
    techDataColsAPINames.STORAGE_TEMPERATURE
  ),
  TECHNICAL_DATA__STORAGE_VOLUME: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.STORAGE_VOLUME),
  TECHNICAL_DATA__SUB_COMPONENT: "Sub Component",
  TECHNICAL_DATA__SYSTEM_NAME: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.SYSTEM_NAME),
  TECHNICAL_DATA__SYSTEM_TYPE: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.SYSTEM_TYPE),
  TECHNICAL_DATA__THICKNESS: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.THICKNESS),
  TECHNICAL_DATA__U_VALUE: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.U_VALUE),
  TECHNICAL_DATA__WINDOW_TYPE: getTechnicalDataColumnsDisplayNamesEnums(techDataColsAPINames.WINDOW_TYPE),
  ...TechnicalDataHeatingCoolingSystemSummaryColsDisplayNamesEnums,
  ...TechnicalDataWindowSummaryColsDisplayNamesEnums,
  ...TechnicalDataSummarySectionsDisplayNamesEnums,
});

export const TechnicalDataHeatingCoolingSystemSummaryColsNamesEnums = Object.freeze({
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__AMOUNT_OF_DIFFERENT_SYSTEMS: getTechDataPrefix(
    "heatingSystemSummary__amountOfDifferentSystems"
  ),
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__INSTALLATION_YEARS: getTechDataPrefix(
    "heatingSystemSummary__installationYears"
  ),
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__MAIN_ENERGY_SOURCE: getTechDataPrefix(
    "heatingSystemSummary__mainEnergySource"
  ),
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__MAIN_SYSTEM_THERMAL_POWER: getTechDataPrefix(
    "heatingSystemSummary__mainSystemThermalPower"
  ),
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__MAIN_SYSTEM_TYPE: getTechDataPrefix("heatingSystemSummary__mainSystemType"),
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__MONITORING_SYSTEM_INSTALLED: getTechDataPrefix(
    "heatingSystemSummary__monitoringSystemInstalled"
  ),
  TECHNICAL_DATA__HEATING_SYSTEM_SUMMARY__TOTAL_THERMAL_POWER: getTechDataPrefix(
    "heatingSystemSummary__totalThermalPower"
  ),
});

export const TechnicalDataWindowSummaryColsNamesEnums = Object.freeze({
  TECHNICAL_DATA__WINDOW_SUMMARY__AMOUNT_OF_DIFFERENT_WINDOWS: getTechDataPrefix(
    "windowSummary__amountOfDifferentWindows"
  ),
  TECHNICAL_DATA__WINDOW_SUMMARY__G_VALUE_RANGE: getTechDataPrefix("windowSummary__gValueRange"),
  TECHNICAL_DATA__WINDOW_SUMMARY__MAIN_WINDOW_TYPE: getTechDataPrefix("windowSummary__mainWindowType"),
  TECHNICAL_DATA__WINDOW_SUMMARY__TOTAL_NUMBER_OF_WINDOWS: getTechDataPrefix("windowSummary__totalNumberOfWindows"),
  TECHNICAL_DATA__WINDOW_SUMMARY__U_VALUE_RANGE: getTechDataPrefix("windowSummary__uValueRange"),
});

export const TechnicalDataColsNamesEnums = Object.freeze({
  TECHNICAL_DATA__AREA: getTechDataPrefix(techDataColsAPINames.AREA),
  TECHNICAL_DATA__AREA_COVERED: getTechDataPrefix(techDataColsAPINames.AREA_COVERED),
  TECHNICAL_DATA__CAPACITY_PANEL: getTechDataPrefix(techDataColsAPINames.CAPACITY_PANEL),
  TECHNICAL_DATA__COLOR: getTechDataPrefix(techDataColsAPINames.COLOR),
  TECHNICAL_DATA__COP: getTechDataPrefix(techDataColsAPINames.COP),
  TECHNICAL_DATA__DC_AC_INVERTER_CONFIGURATION: getTechDataPrefix(techDataColsAPINames.DC_AC_INVERTER_CONFIGURATION),
  TECHNICAL_DATA__DESCRIPTION: getTechDataPrefix(techDataColsAPINames.DESCRIPTION),
  TECHNICAL_DATA__DISTRIBUTION_LOSSES: getTechDataPrefix(techDataColsAPINames.DISTRIBUTION_LOSSES),
  TECHNICAL_DATA__ENERGY_SOURCE: getTechDataPrefix(techDataColsAPINames.ENERGY_SOURCE),
  TECHNICAL_DATA__G_VALUE: getTechDataPrefix(techDataColsAPINames.G_VALUE),
  TECHNICAL_DATA__INFILTRATION: getTechDataPrefix(techDataColsAPINames.INFILTRATION),
  TECHNICAL_DATA__INSTALLED: getTechDataPrefix(techDataColsAPINames.INSTALLED),
  TECHNICAL_DATA__LAST_CHECKED: getTechDataPrefix(techDataColsAPINames.LAST_CHECKED),
  TECHNICAL_DATA__MANUFACTURER_NAME: getTechDataPrefix(techDataColsAPINames.MANUFACTURER_NAME),
  TECHNICAL_DATA__MODERNIZATION: getTechDataPrefix(techDataColsAPINames.MODERNIZATION),
  TECHNICAL_DATA__MONITORING_INSTALLED: getTechDataPrefix(techDataColsAPINames.MONITORING_INSTALLED),
  TECHNICAL_DATA__NUMBER_OF_WINDOWS: getTechDataPrefix(techDataColsAPINames.NUMBER_OF_WINDOWS),
  TECHNICAL_DATA__PEAK_THERMAL_POWER: getTechDataPrefix(techDataColsAPINames.PEAK_THERMAL_POWER),
  TECHNICAL_DATA__STORAGE_LOSSES: getTechDataPrefix(techDataColsAPINames.STORAGE_LOSSES),
  TECHNICAL_DATA__STORAGE_TEMPERATURE: getTechDataPrefix(techDataColsAPINames.STORAGE_TEMPERATURE),
  TECHNICAL_DATA__STORAGE_VOLUME: getTechDataPrefix(techDataColsAPINames.STORAGE_VOLUME),
  TECHNICAL_DATA__SUB_COMPONENT: getTechDataPrefix("SUB_COMPONENT"),
  TECHNICAL_DATA__SYSTEM_NAME: getTechDataPrefix(techDataColsAPINames.SYSTEM_NAME),
  TECHNICAL_DATA__SYSTEM_TYPE: getTechDataPrefix(techDataColsAPINames.SYSTEM_TYPE),
  TECHNICAL_DATA__THICKNESS: getTechDataPrefix(techDataColsAPINames.THICKNESS),
  TECHNICAL_DATA__U_VALUE: getTechDataPrefix(techDataColsAPINames.U_VALUE),
  TECHNICAL_DATA__WINDOW_TYPE: getTechDataPrefix(techDataColsAPINames.WINDOW_TYPE),
  ...TechnicalDataHeatingCoolingSystemSummaryColsNamesEnums,
  ...TechnicalDataWindowSummaryColsNamesEnums,
  ...TechnicalDataSummarySectionsNamesEnums,
});
